/**
 * Route for `igaming-funnel`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingFunnelPage } from "../features/igaming-funnel/IgamingFunnelPage";

export const igamingFunnelRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-funnel",
	component: IgamingFunnelPage,
});

export default igamingFunnelRoute;
